import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import IconButton from '@material-ui/core/IconButton'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import AddIcon from '@material-ui/icons/Add'
import * as Constants from '../../constants/constants'
import Icon from '@material-ui/core/Icon'
import constSubmittedType from '../../constants/submittedType'
import useTranslate from '../../i18n/useTranslate'
import { ReactComponent as FolderIcon } from '../../images/folder.svg'
import Tooltip from '../tooltip/tooltip'
import { NoteAdd } from '@material-ui/icons'

const drawerWidth = 240

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    iconColor: {
        color: 'white',
    },
    lastestIconColor: {
        color: '#d8943f',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    test: {
        position: 'unset',
        overflowY: 'unset',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
    },
    listItemRoot: {
        color: 'white',
        backgroundColor: '#58a4b0',
        borderTopLeftRadius: '10px',
        borderBottomLeftRadius: '10px',
        marginBottom: '10px',
        width: 'calc(100% - 15px)',
        marginLeft: '15px',
        '&:hover': { backgroundColor: '#65b9c7' },

        '&$selected': {
            backgroundColor: '#58a4b0',
            marginLeft: '0px',
            '&:hover': {
                backgroundColor: '#65b9c7',
            },
        },
    },

    uploadFileRoot: {
        color: 'white',
        backgroundColor: '#a16107',
        borderTopLeftRadius: '10px',
        borderBottomLeftRadius: '10px',
        marginBottom: '10px',
        width: 'calc(100% - 15px)',
        marginLeft: '15px',
        '&:hover': { backgroundColor: '#c17d1a' },

        '&$selected': {
            backgroundColor: '#a16107',
            marginLeft: '0px',
            '&:hover': {
                backgroundColor: '#c17d1a',
            },
        },
    },
    selected: {},

    listItemlastest: {
        color: '#d8943f',
        backgroundColor: '#fcdc4d',
        borderRadius: '10px',
        marginBottom: '10px',
        width: 'calc(100% + 10px)',
        marginLeft: '15px',
        '&:hover': { backgroundColor: '#ffe674' },

        '&$selected': {
            backgroundColor: '#fcdc4d',
            marginLeft: '0px',
            '&:hover': {
                backgroundColor: '#ffe674',
            },
        },
    },
}))

const getFolderIcon = (itm: any) => {
    const submittedTypeID = itm?.submittedTypeID
    let iconPath = <></>
    switch (submittedTypeID) {
        case constSubmittedType.firstSubmitConsideration:
        case constSubmittedType.editAfterReview:
        case Constants.customFolder.createProject.id:
            iconPath = <FolderIcon style={{ fill: '#0a0000' }} />
            break

        case constSubmittedType.nextPhaseProject:
        case constSubmittedType.editAfterReview_nextPhaseProject:
        case Constants.customFolder.projectPhase.id:
            iconPath = <FolderIcon style={{ fill: '#0019ff' }} />
            break

        case constSubmittedType.renewalProject:
        case constSubmittedType.editAfterReview_renewalProject:
        case Constants.customFolder.projectRenewal.id:
            iconPath = <FolderIcon style={{ fill: '#00f2ff' }} />
            break

        case constSubmittedType.amendmentProject:
        case constSubmittedType.exitAfterReview_AmendmentProject:
        case constSubmittedType.renewalAndAmendmentProject:
        case constSubmittedType.editAfterReviewRenewalAndAmendmentProject:
        case Constants.customFolder.projectAmendment.id:
            iconPath = <FolderIcon style={{ fill: '#9800ff' }} />
            break

        case constSubmittedType.adverseEvent:
        case constSubmittedType.highRiskProjectProgressReport:
        case constSubmittedType.projectSiteVisit:
        case constSubmittedType.editAfterReviewHighRiskProjectProgressReport:
        case constSubmittedType.editAfterReviewProjectSiteVisit:
        case Constants.customFolder.adverseEvents.id:
            iconPath = <FolderIcon style={{ fill: '#f4660e' }} />
            break

        case constSubmittedType.nonconformance:
        case Constants.customFolder.raeProject.id:
            iconPath = <FolderIcon style={{ fill: '#cc4a00' }} />
            break

        case constSubmittedType.closeProject:
        case constSubmittedType.editAfterReview_closeProject:
        case constSubmittedType.closeProjectByAdmin:
        case Constants.customFolder.closeProject.id:
        case Constants.customFolder.closeProjectByAdmin.id:
            iconPath = <FolderIcon style={{ fill: '#00d635' }} />
            break

        case constSubmittedType.terminateProject:
        case constSubmittedType.editAfterReview_terminateProject:
        case constSubmittedType.terminateProjectByAdmin:
        case Constants.customFolder.terminateProject.id:
        case Constants.customFolder.terminateProjectByAdmin.id:
            iconPath = <FolderIcon style={{ fill: '#5e200a' }} />
            break

        case constSubmittedType.withdrawalProject:
        case constSubmittedType.withdrawalSubmitted:
        case Constants.customFolder.withdrawProject.id:
        case Constants.customFolder.withdrawSubmitted.id:
            iconPath = <FolderIcon style={{ fill: '#ff0000' }} />
            break

        case constSubmittedType.firstSubmitConsideration_notScope:
            iconPath = <FolderIcon style={{ fill: '#f709f7' }} />
            break

        case Constants.customFolder.docAdditional.id:
            iconPath = <AddIcon style={{ color: '#0a0000' }} />
            break

        case constSubmittedType.projectFilesUpload:
            iconPath = <NoteAdd style={{ fill: '#ffffff' }} />
            break

        default:
            iconPath = <></>
            break
    }

    return <Icon>{iconPath}</Icon>
}

export default function MiniDrawer(props: any) {
    const { children, menuFolderList = [], onClickMenu, folderSelected } = props
    const [open, setOpen] = React.useState(false)
    const classes = useStyles({ open })
    const translate = useTranslate()

    const handleDrawerOpen = () => {
        setOpen(!open)
    }

    return (
        <div className={classes.root}>
            <React.Fragment>
                <Drawer
                    variant="permanent"
                    className={clsx(classes.drawer, {
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    })}
                    classes={{
                        paper: clsx(classes.test, {
                            [classes.drawerOpen]: open,
                            [classes.drawerClose]: !open,
                        }),
                    }}
                >
                    <div className={classes.toolbar}>
                        <IconButton onClick={handleDrawerOpen}>
                            {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                        </IconButton>
                    </div>
                    <List>
                        {menuFolderList?.map((itm: any, index: number) => (
                            <Tooltip
                                title={
                                    translate.languageStore.currentLanguage === 'th'
                                        ? itm.folderName_th
                                        : itm.folderName_en
                                }
                                placement={'top-start'}
                            >
                                <ListItem
                                    button
                                    key={index}
                                    classes={{
                                        root: itm.isLastProcess ? classes.listItemlastest : classes.listItemRoot,
                                        selected: classes.selected,
                                    }}
                                    onClick={() => {
                                        if (onClickMenu) {
                                            onClickMenu(itm)
                                        }
                                    }}
                                    selected={folderSelected === itm.id}
                                >
                                    <ListItemIcon
                                        classes={{
                                            root: itm.isLastProcess ? classes.lastestIconColor : classes.iconColor,
                                        }}
                                        style={{ minWidth: itm.isLastProcess ? '' : '50px' }}
                                    >
                                        {getFolderIcon(itm)}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={
                                            translate.languageStore.currentLanguage === 'th'
                                                ? itm.folderName_th
                                                : itm.folderName_en
                                        }
                                    />
                                </ListItem>
                            </Tooltip>
                        ))}
                    </List>
                </Drawer>

                <main className={classes.content}>{children}</main>
            </React.Fragment>
        </div>
    )
}
